import {ID, Response} from '../../../../../../_metronic/helpers'
import {FieldProps} from '../../../../../../_component/Form'

export type ContactUs = {
  id?: ID
  name?: string
  email?: string
  subject?: string
  note?: string
  status?: boolean
  message?: string
}

export type ContactUssQueryResponse = Response<Array<ContactUs>>

  const generateUniqueNumber = () => {
    return `${Date.now()}${Math.floor(Math.random() * 1000)}`
  }
   const generated = generateUniqueNumber()
export const fields: FieldProps[] = [
  {
    name: 'ticketid',
    label: 'Ticket ID',
    hidden: true,
    disabled: true,
    initialValue: generated,
  },
  {name: 'name', label: 'Name', required: true, table: true, sortable: true, full: false},
  {
    name: 'email',
    label: 'Email',
    required: true,
    table: false,
    sortable: true,
    full: false,
  },
  {name: 'subject', label: 'Subject', required: true, table: true, sortable: true, full: false},
  {
    name: 'status',
    label: 'Status',
    type: 'switch',
    truthValue: 'Active',
    falseValue: 'Inactive',
    table: true,
    sortable: true,
    full: false,
  },
  {name: 'message', label: 'Message', type: 'textarea', full: true, table: false},
]
